import React, { Component } from 'react'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import SetCSDueDateModalUI from './SetCSDueDateModalUI'

/**
 * SetCSDueDateModalSF
 *
 * Stateful container for the "Set CS Due Date" modal.
 *
 * Props:
 *   context          - app context
 *   loan             - current loan entity
 *   setDueDateMode   - boolean — whether the modal is open
 *   selectedFileCode - file code of the CS doc
 *   selectedFileTitle- human-readable title for display
 *   onCancelClick    - function() to close the modal
 *   onRefreshClick   - function() to reload loan data after success
 */
class SetCSDueDateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dueDate: null,       // ISO date string from InputDateUI e.g. "2026-03-03"
      submitted: false,
      successMsg: null,
      errorList: [],
    }
  }

  // Reset local state whenever the modal is newly opened for a (possibly different) file
  componentDidUpdate(prevProps) {
    if (!prevProps.setDueDateMode && this.props.setDueDateMode) {
      this.setState({
        dueDate: null,
        submitted: false,
        successMsg: null,
        errorList: [],
      })
    }
  }

  onDueDateChange = (isoDateString) => {
    this.setState({ dueDate: isoDateString })
  }

  onSubmitClick = () => {
    const { dueDate } = this.state
    if (!dueDate) return

    // Convert ISO date ("2026-03-03") to epoch-millis string, matching backend expectation
    const epochMillis = String(new Date(dueDate).getTime())

    this.setState({ submitted: true, successMsg: null, errorList: [] })

    RestApiUtils.put(
      this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/csdocuments/${this.props.selectedFileCode}/dueDate`,
      this.onSubmitCallback,
      { dueDate: epochMillis }
    )
  }

  onSubmitCallback = (response) => {
    const errorList = response.errorList
      ? response.errorList.map(e => e.message)
      : []

    this.setState({
      submitted: false,
      successMsg: errorList.length === 0 ? response.success || 'Due date set successfully.' : null,
      errorList,
    })

    if (errorList.length === 0) {
      // Auto-close after a brief success flash and refresh parent
      setTimeout(() => {
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 1200)
    }
  }

  render() {
    const { context, loan, setDueDateMode, selectedFileCode, selectedFileTitle, onCancelClick } = this.props
    const { dueDate, submitted, successMsg, errorList } = this.state

    return (
      <SetCSDueDateModalUI
        context={context}
        loan={loan}
        setDueDateMode={setDueDateMode}
        selectedFileCode={selectedFileCode}
        selectedFileTitle={selectedFileTitle}
        dueDate={dueDate}
        onDueDateChange={this.onDueDateChange}
        submitted={submitted}
        successMsg={successMsg}
        errorList={errorList}
        onSubmitClick={this.onSubmitClick}
        onCancelClick={onCancelClick}
      />
    )
  }
}

export default SetCSDueDateModalSF